import React from 'react';

import '../styling.scss';

const Row = (props: any) => {
	return <div className="edfmat_row">{props.children}</div>;
};

export default Row;
